import React from "react";
import {LibraryDomainUseDTO, LibraryDTO} from "../../../models/library";
import {createStyles, makeStyles, Theme} from "@material-ui/core/styles";
import {Box} from "@material-ui/core";
import {InfoActionButton} from "../../common/buttons";
import {DomainDialog} from "../../values/dialogs/DomainDialog";
import {LibraryGoalBrowser} from "./LibraryGoalBrowser";
import {compareByAttr} from "../../../utils/compare";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import IconButton from "@material-ui/core/IconButton";

interface LibraryDomainBrowserProps {
    library: LibraryDTO;
    libraryDomainUse: LibraryDomainUseDTO;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        domainCard: {
            border: "1px solid #E5E7EB",
            borderRadius: "8px",
            backgroundColor: "#ffffff",
            marginBottom: theme.spacing(1),
            overflow: "hidden",
        },
        domainRow: {
            display: "flex",
            alignItems: "center",
            padding: `${theme.spacing(1.5)}px ${theme.spacing(2)}px`,
            cursor: "pointer",
            "&:hover": {
                backgroundColor: "#F9FAFB",
            },
        },
        chevron: {
            color: "#6B7280",
            padding: "4px",
            marginRight: theme.spacing(0.5),
        },
        domainName: {
            flexGrow: 1,
            fontSize: "0.9375rem",
            fontWeight: 600,
            color: "#111827",
        },
        goalsContainer: {
            borderTop: "1px solid #F3F4F6",
        },
    })
);

export const LibraryDomainBrowser: React.FC<LibraryDomainBrowserProps> = (props: LibraryDomainBrowserProps) => {
    const classes = useStyles();
    const [infoOpen, setInfoOpen] = React.useState(false);
    const [childOpen, setChildOpen] = React.useState(false);

    return (
        <Box className={classes.domainCard}>
            <Box className={classes.domainRow} onClick={() => setChildOpen(!childOpen)}>
                <IconButton
                    className={classes.chevron}
                    size="small"
                    onClick={(e) => {
                        e.stopPropagation();
                        setChildOpen(!childOpen);
                    }}
                >
                    {childOpen ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
                </IconButton>
                <Box className={classes.domainName}>{props.libraryDomainUse.domain.name}</Box>
                <Box onClick={(e) => e.stopPropagation()}>
                    <InfoActionButton onClick={() => setInfoOpen(true)} />
                </Box>
                <DomainDialog
                    domain={props.libraryDomainUse.domain}
                    handleClose={() => setInfoOpen(false)}
                    open={infoOpen}
                />
            </Box>
            {childOpen && (
                <Box className={classes.goalsContainer}>
                    {props.libraryDomainUse.libraryGoalUses.sort(compareByAttr("order", "ascending")).map((goal) => (
                        <LibraryGoalBrowser key={goal.id} libraryGoalUse={goal} {...props} />
                    ))}
                </Box>
            )}
        </Box>
    );
};
